import React, { useEffect, useState } from "react";
import I18n from 'i18n.js.erb'
import { parseBigInteger } from "../../utils/utils";

const BannerMultipleExpansionsCompact = ({
  expansions,
  handleShowSubExpansions,
  hideCounts
}) => {

  const iconsToRender = expansions[0].icons_urls.map((url) => {
    return url;
  });

  for (let i = 1; i < expansions.length; i++) {
    for (const url of expansions[i].icons_urls)
      if (!iconsToRender.includes(url)) iconsToRender.push(url);
  }

  let aiGCardsPopulation = 0
  expansions.forEach((expansion) => {
    aiGCardsPopulation = aiGCardsPopulation + expansion.graded_cards_population
  })

  let blueprintImagesOnMyCollection = 0
  expansions.forEach((expansion) => {
    blueprintImagesOnMyCollection = blueprintImagesOnMyCollection + expansion.blueprint_images_on_my_collection
  })

  let countueprintImages = 0
  expansions.forEach((expansion) => {
    countueprintImages = countueprintImages + expansion.count_blueprint_images
  })

  for (let i = 1; i < expansions.length; i++) {
    for (const url of expansions[i].icons_urls)
      if (!iconsToRender.includes(url)) iconsToRender.push(url);
  }

  return (
      <React.Fragment>
        <div className="col-12 d-flex bg-hover align-items-center expansion-container-compact border-bottom-dark minH-35px pr-0 pl-0"
             onClick={(e) => handleShowSubExpansions(e, expansions[0])}>
          <div className="col-1 text-aiBlue">
            <b>{expansions[0].released_at.split('#')[0].toUpperCase()}</b>
          </div>
          <div className="col-3 text-truncate"><b>{expansions[0].name}</b></div>
          <div className="col-4 text-truncate"><b>{expansions[0].en_name}</b></div>
          <div className="col-2">
            {
              expansions[0].icons_urls.map((url, i) => {
                return (
                  <div key={url + "_" + i} className="col-xs-2 col-lg-1 mr-4">
                    <img
                      src={url}
                      className="expansion__symbol--size img-size-logo-navbar"
                    />
                  </div>
                );
              })
            }
          </div>
          <div className="col-1 p-0 text-aiBlue">
            {
              !hideCounts &&
              <small>
                <span>
                  {I18n.t('js.expansionsPage.aigCard')}:&nbsp;
                  {parseBigInteger(aiGCardsPopulation)}
                </span>
              </small>
            }
          </div>
          <div className="col-1 p-0 text-aiBlue">
            {
              !hideCounts &&
              <small>
                <span>
                  {I18n.t('js.expansionsPage.myCollection')}:&nbsp;
                  {blueprintImagesOnMyCollection}/{countueprintImages}
                </span>
              </small>
            }
          </div>
        </div>
      </React.Fragment>

  );
};

export default BannerMultipleExpansionsCompact;
